import { motion } from 'framer-motion';
import './closing.scss';

export default function Closing() {
  const handleGoogleMaps = () => {
    window.open('https://www.google.com/maps/dir//Av.+%C3%81lvares+Cabral,+894+-+Lourdes,+Belo+Horizonte+-+MG', '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="closing">
      <div className="container">
        <motion.div 
          className="closing-content"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="closing-title">Sua lavanderia em Lourdes, sem complicação</h2>
          <p className="closing-subtitle">Lave, seque e resolva tudo em um só lugar.</p>
          
          <motion.button 
            onClick={handleGoogleMaps}
            className="closing-btn"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <i className="ri-map-pin-line"></i>
            Abrir rota e ir agora
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
}
